var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowBanner)?_c('div',{class:[
    'pointer-events-none fixed top-0 left-0 z-50 w-full text-white py-3 px-4 shadow-md flex items-center',
    _vm.storeStatus === 'closed' ? 'bg-red-600' : 'bg-yellow-600'
  ]},[_c('div',{staticClass:"container mx-auto flex items-center justify-center gap-2"},[_c('AlertCircle',{staticClass:"w-5 h-5 flex-shrink-0"}),_c('p',{staticClass:"text-sm font-medium text-center"},[_vm._v(" "+_vm._s(_vm.bannerMessage)+" ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }